import React, { Fragment } from 'react';
import { ApiHelper } from '../helpers/ApiHelper';
import { Helper } from '../helpers/Helper';
import { BaseEntityPage } from './BaseEntityPage';
import { Controller } from '../Controller';
import { UiHelper } from '../helpers/UiHelper';
import { AppConfig } from '../../AppConfig';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { adminRoleDropdownFieldDef, customRoleDropdownFieldDef, partnerRoleDropdownFieldDef } from '../../data/data';
import { css, StyleSheet } from 'aphrodite';
import { SearchBar } from './SearchBar';
import moment from 'moment';

export class UsersOfOrg extends BaseEntityPage {

  constructor(props, {pageForOrgType}) {
    super(props)
    this.pageForOrgType = pageForOrgType
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.teamId = this.props.match.params.id
    this.pageTitle = this.orgId === 'PRODUCT' ? Helper.getString('productadmins') : Helper.getString('admins')
    if(this.teamId) {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
        { title: Helper.getString('teams'), to: this.baseRoute() + '/teams' },
        { title: this.teamId ? Helper.getString('users') : Helper.getString('admins') },
      ]
    } else {
      this.breadCrumbs = [
        { title: Helper.getString('home'), to: Controller.get().roleHelper().getHome() },
        { title: this.teamId ? Helper.getString('users') : Helper.getString('users') },
      ]
    }
    this.toFetch = [
      { method: 'GET', endPoint: ApiHelper.makeUrlPath(['users'], { orgId: this.teamId || this.orgId, pb: 'fieldDef', limit: 500 }) },
    ]
    if(this.orgId !== 'PRODUCT') {
      this.toFetch.push({ method: 'GET', endPoint: ApiHelper.makeUrlPath(['orgs', this.teamId || this.orgId]) })
    }
    this.tableHeadersMap = {
      Index: (current) => { return current.__index + 1 },
      Email: (current) => {
        const alerts = Array.isArray(current.alerts) ? current.alerts : []
        return (
          <div>
            {current.email}
            {/* {alerts.length > 0 &&
              <div className={css(Styles.alertsContainer)}>
                {alerts.map((alert, index) => (
                  <Fragment key={`${alert}-${index}`}>
                    {AppUiHelper.chipPurple(alert, false)}
                  </Fragment>
                ))}
              </div>
            } */}
          </div>
        )
      },
      Name: (current) => { return Helper.formatName(current) },
      Roles: (current) => { // Changed role style for all
        // if (current.roles && current.roles.includes('SUPERUSER')) {
        // Replace SUPERUSER with ADMIN
        const modifiedRoles = current.roles.map(role => role === 'SUPERUSER' ? 'ADMIN' : role);
        return AppUiHelper.getChipsFromArray(modifiedRoles);
        // }
        // return current.roles ? AppUiHelper.getChipsFromArray(current.roles) : '';
      }
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    // if (this.pageForOrgType !== 'PARTNER') {
    //   this.tableHeaders = this.tableHeaders.filter((header) => header !== 'Alerts')
    // }
    this.emptyText = 'No users in this org yet!'
    this.apiData = {}
    this.pageKey = 'UsersOfOrg'
    this.export = {
      buttonTitle: 'Download',
      headers: {
        email: 'Email',
        name: 'Name',
        roles: 'Roles'
      },
      format: 'xlsx'
    }

    this.defaultRole = '_ALL'
    this.defaultItems = []
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  makeFileName = () => {
    return `dd-users-${moment().format('MM-DD-YYYY')}`
  }

  exportRowItemValue(key, current) {
    switch (key) {
    case 'name':
      return [current.givenname, current.familyname].filter(Boolean).join(' ')
    case 'roles':
      return (current.roles || []).map(role => role === 'SUPERUSER' ? 'ADMIN' : role).join(', ')
    default:
      return super.exportRowItemValue(key, current) || ''
    }
  }

  onFetchSuccess(results) {
    this.formDefinition = results[0].fieldDef
    const rolesField = this.formDefinition.steps[0].fields.find(i => i.key === 'roles')
    if(this.teamId) {
      rolesField.options = [
        { key: 'MANAGER', label: 'MANAGER' },
        { key: 'MEMBER', label: 'MEMBER' },
      ]
    } else {
      rolesField.options = [
        { key: 'SUPERUSER', label: 'ADMIN' }
      ]
    }

    results[0].items.forEach(i => i.id = i.userId)

    this.defaultItems = results[0].items
    const roleDropdown = [{ key: this.defaultRole, value: 'ALL' }]

    const baseUserFields = ['email', 'givenname', 'familyname']
    if (this.pageForOrgType === 'PARTNER') {
      baseUserFields.push('alerts')
    }

    this.formDefinition.steps[0].fields = this.formDefinition.steps[0].fields.filter(f => {
      return Helper.inArray(baseUserFields, f.key)
    })

    // PARTNER
    if (this.pageForOrgType && this.pageForOrgType === 'PARTNER') {
      if (this.formDefinition && this.formDefinition.steps[0] && this.formDefinition.steps[0].fields) {
        this.formDefinition.steps[0].fields.push(partnerRoleDropdownFieldDef)
      }
      partnerRoleDropdownFieldDef.options.map(e => {
        roleDropdown.push({ key: e.key, value: e.label })
      })
    } else if (this.pageForOrgType && this.pageForOrgType === 'CUSTOM') { // NON PARTNER BO
      // if (this.formDefinition && this.formDefinition.steps[0] && this.formDefinition.steps[0].fields) {
      //   this.formDefinition.steps[0].fields.push(customRoleDropdownFieldDef)
      // }
      // customRoleDropdownFieldDef.options.map(e => {
      //   roleDropdown.push({ key: e.key, value: e.label })
      // })
    } else { /* BO - Default */
      if (this.formDefinition && this.formDefinition.steps[0] && this.formDefinition.steps[0].fields) {
        this.formDefinition.steps[0].fields.push(adminRoleDropdownFieldDef)
      }
      adminRoleDropdownFieldDef.options.map(e => {
        roleDropdown.push({ key: e.key, value: e.label })
      })
    }

    this.setState({
      items: results[0].items,
      searchText: '',
      roleDropdown: roleDropdown,
      selectedRole: this.defaultRole
    })
  }

  onAdd() {
    this.formDefinition.steps[0].fields.find(i => i.key === 'email').disabled = false
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        updateAction: 'addMembers',
        ...(this.pageForOrgType && this.pageForOrgType !== 'PARTNER' ? { roles: ['SUPERUSER'] } : {})
      },
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', this.teamId || this.orgId]),
    });
  }

  onDelete(current) {
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        updateAction: 'delMembers',
      },
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', this.teamId || this.orgId]),
    });
  }

  onEdit(current) {
    this.formDefinition.steps[0].fields.find(i => i.key === 'email').disabled = true
    this.setState({
      apiMethod: 'PUT',
      apiData: {
        updateAction: 'addMembers',
        ...(this.pageForOrgType && this.pageForOrgType !== 'PARTNER' ? { roles: ['SUPERUSER'] } : {})
      },
      apiEndPoint: ApiHelper.makeUrlPath(['orgs', this.teamId || this.orgId]),
    });
  }

  onActions(current) {
    const actions = []
    actions.push(UiHelper.buttonEdit(this, current))
    actions.push(UiHelper.buttonDelete(this, current))
    return actions
  }

  _onSearch = (searchText, selectedRole = []) => {
    this.setState({
      searchText: searchText
    }, this._localSearch)
  }

  _onRoleChangeHandle = (e) => {
    const selectedState = e.target.value
    this.setState({
      selectedRole: selectedState
    }, () => {
      // console.log('Role Changed')
    })
  }

  _onList = (e) => {
    const selectedState = e.target.value
    this.setState({
      searchText: '',
      selectedRole: this.defaultRole,
      items: this.defaultItems
    }, this._localSearch)
  }

  _localSearch = () => {
    const q = (this.state.searchText) ? this.state.searchText.trim().toLowerCase() : ''
    const filteredItems = this.defaultItems.filter(user => {
      // Role check if not selected ALL
      if (this.state.selectedRole !== this.defaultRole) {
        const hasRole = user.roles && this.state.selectedRole && user.roles.includes(this.state.selectedRole);
        if (!hasRole) return false;
      }
      // Query check (in givenname, familyname, or email)
      const searchString = [
        user.givenname || '',
        user.familyname || '',
        user.email || ''
      ].join(' ').toLowerCase();

      return q === '' || searchString.includes(q);
    })
    this.setState({
      items: filteredItems
    })
  }

  _renderSearchBar() {
    return (
      <SearchBar
        onSearch={this._onSearch}
        searchText={this.state.searchText}
        onSinglePickerFilter={this._onRoleChangeHandle}
        singleSelectPicker={{
          options: this.state.roleDropdown,
          defaultValue: this.state.selectedRole,
        }}
        resetFilterText={'Reset Filter'}
        onList={this._onList}
      />
    );
  }

  renderAboveTable() {
    return (
      <Fragment>
        {(this.pageForOrgType !== 'CUSTOM') &&
          <div className={css(Styles.fullSearchBar)}>
            {this._renderSearchBar()}
          </div>
        }
      </Fragment>
    )
  }

}


const Styles = StyleSheet.create({
  fullSearchBar: {
    display: 'flex',
    width: '100%'
  },
  alertsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
    marginTop: 6
  }
})


// WEBPACK FOOTER //
// ./src/common/components/UsersOfOrg.js